import { Component, OnInit, Inject } from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { InventoryService } from './inventory.service';
import { NotifyService } from '../shared/services/notify.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

declare var moment:any;

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})
export class CreateComponent implements OnInit {

  iForm: FormGroup;
  materials: any[] = [];
  suppliers: any[] = [];
  jobNames: any[] = [];
  customers: any[] = [];
  locations: any[] = [];
  inventoryTypes:string[] = [];
  slabTypes:string[] = [];
  colors:any[] = [];
  finishes:string[] = [];
  thicks:number[] = [];
  lshapes:string[] = [];
  users:any[] = [];
  saws:string[] = [];
  statuses:string[] = [];

  constructor(
    @Inject(FormBuilder) fb: FormBuilder,
    private _appService: AppService,
    private _invService: InventoryService,
    private _notifyService: NotifyService
  ) {
    this.iForm = fb.group({
      id: [null],
      jobName: [null],
      jobNum: [null],
      poNum: [null],
      location: [null, Validators.required],
      slabType: [null, Validators.required],
      inventoryType: [null, Validators.required],
      material: [null, Validators.required],
      color: [null, Validators.required],
      finish: [null],
      lot: [null],
      length: [null, Validators.required],
      thickness: [null, Validators.required],
      width: [null, Validators.required],
      lShape: [null],
      lDirection: [null],
      lLength: [null],
      lWidth: [null],
      supplier: [null],
      shippingPrice: [null],
      slabPrice: [null],
      costSqFt: [0],
      remnantPrice: [0],
      needed: [null],
      eDelivery: [null],
      received: [null],
      customerFirst: [null],
      customerLast: [null],
      customerCompany: [null],
      notes: [null],
      slabCount: [1, Validators.required],
      cutBy: [null],
      cutDate: [null],
      cutSaw: [null],
      status: ['Active', Validators.required]
    });


    this._invService.editReady$.subscribe(
      data => {
        console.log('edit data is ready');
        this.iForm.get('slabCount').disable();
        this._appService.hideLoader();
        this.getEditData(data);
      }
    );
  }

  ngOnInit() {
    this._invService.getLists().subscribe(
      data => {
        this.jobNames = data.lists.jobNames;
        this.customers = data.lists.customers;
        this.suppliers = data.lists.suppliers;
        //this.suppliers.unshift({name:null});
        this.materials = data.lists.materials;
        //this.materials.unshift({name:null, colors:[]});
        this.locations = data.lists.locations;
        //this.locations.unshift({name:null});
        this.users = data.lists.users;
        //this.users.unshift({usernmae:null});
      }
    );

    this.inventoryTypes = this._invService.getInventoryTypes();
    //this.inventoryTypes.unshift(null);
    this.slabTypes = this._invService.getSlabTypes();
    //this.slabTypes.unshift(null);
    this.finishes = this._invService.getFinishes();
    //this.finishes.unshift(null);
    this.thicks = this._invService.getThicks();
    //this.thicks.unshift(null);
    this.saws = this._invService.getSaws();
    //this.saws.unshift(null);
    this.statuses = this._invService.getStatuses();
  }

  getEditData(inv) {
    if(!inv) return;
    this.iForm.get('id').setValue(inv._id);
    this.iForm.get('status').setValue(inv.status);
    if(inv.job) {
      this.iForm.get('jobNum').setValue(inv.job.number);
      this.iForm.get('jobName').setValue(inv.job.name);
    }
    this.iForm.get('poNum').setValue(inv.po);
    this.iForm.get('location').setValue(inv.location);
    this.iForm.get('slabType').setValue(inv.slabType);
    this.iForm.get('inventoryType').setValue(inv.inventoryType);
    this.iForm.get('material').setValue(inv.material);
    this.setColors();
    setTimeout(() => {
      if(inv.color) {
        this.iForm.get('color').setValue(inv.color.name);
      }
    }, 500);
    this.iForm.get('finish').setValue(inv.finish);
    this.iForm.get('lot').setValue(inv.lot);
    if(inv.dimensions) {
      this.iForm.get('length').setValue(inv.dimensions.length);
      this.iForm.get('width').setValue(inv.dimensions.width);
      this.iForm.get('thickness').setValue(inv.dimensions.thickness);
      if(inv.dimensions.lShape.direction) {
        this.iForm.get('lShape').setValue(true);
        this.iForm.get('lDirection').setValue(inv.dimensions.lShape.direction);
        this.iForm.get('lLength').setValue(inv.dimensions.lShape.length);
        this.iForm.get('lWidth').setValue(inv.dimensions.lShape.width);
      }
    }
    if(inv.supplier) {
      this.iForm.get('supplier').setValue(inv.supplier);
    }
    if(inv.price) {
      this.iForm.get('shippingPrice').setValue(inv.price.shipping);
      this.iForm.get('slabPrice').setValue(inv.price.slab);
      this.iForm.get('costSqFt').setValue(inv.price.sqFt);
      this.iForm.get('remnantPrice').setValue(inv.price.remnant);
    }
    // if(inv.dates) {
    //   if(inv.dates.needed) {
    //     let d = moment(inv.dates.needed);
    //     this.iForm.get('needed').setValue({
    //       year: d.format('YYYY'),
    //       month: d.format('MM'),
    //       day: d.format('DD')
    //     });
    //   }
    //   this.iForm.get('eDelivery').setValue(moment(inv.dates.estDelivery).format('MM-DD-YYYY'));
    //   this.iForm.get('received').setValue(moment(inv.dates.received).format('MM-DD-YYYY'));
    // }
    if(inv.customer){
      if(inv.customer.company) {
        this.iForm.get('customerCompany').setValue(inv.customer.company.name);
      }
      if(inv.customer.name) {
        this.iForm.get('customerFirst').setValue(inv.customer.name.first);
        this.iForm.get('customerLast').setValue(inv.customer.name.last);
      }
    }
    if(inv.cut){
      if(inv.cut.by) {
        this.iForm.get('cutBy').setValue(inv.cut.by._id);
      }
      // const d = moment(inv.cut.date);
      // const ds:NgbDateStruct = {year:d.format('YYYY'), month: d.format('MM'), day: d.format('DD')};
      //this.iForm.get('cutDate').setValue(moment(inv.cut.date).format('YYYY-MM-DD'));
      this.iForm.get('cutSaw').setValue(inv.cut.saw);
    }
    this.iForm.get('slabCount').setValue(inv.slabCount);

  }

  getCutDate() {
    return this.iForm.get('cutDate').value;
  }

  addInventory() {
    this._appService.showLoader();
    if(this.iForm.get('id').value) {
      this._invService.update(this.iForm.value).subscribe(
        data => {
          this.cancel();
          this._appService.hideLoader();
          this._invService.setAddShow(false);
          this._notifyService.setNote({
            styleClass: 'alert-success',
            heading: 'Success!',
            body: 'Inventory item updated.'
          });
          this._invService.setAddShow(false);
        },
        error => {
          this._appService.hideLoader();
          this._notifyService.setNote({
            styleClass: 'alert-danger',
            heading: 'Oops!',
            body: 'We were not able to update that item.'
          });
        }
      );
    } else {
      this._invService.create(this.iForm.value).subscribe(
        data => {
          this.cancel();
          this._appService.hideLoader();
          this._invService.setAddShow(false);
          this._notifyService.setNote({
            styleClass: 'alert-success',
            heading: 'Success!',
            body: 'Inventory item has been created'
          });
          data.inventory.forEach( (item) => {
            this._invService.addRow(item);
          });

        },
        error => {

          this._appService.hideLoader();
          this._notifyService.setNote({
            styleClass: 'alert-danger',
            heading: 'Oops!',
            body: 'We were not able to save that item.'
          });
        }
      );
    }
  }

  hideAdd() {
    this.iForm.reset();
    this._invService.setAddShow(false);
  }

  searchJobName = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.jobNames.filter(job => new RegExp(term, 'gi').test(job)).splice(0, 10));

  searchCustomers = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.customers.filter(c => new RegExp(term, 'gi').test(c)).splice(0, 10));

  searchSuppliers = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.suppliers.filter(sup => new RegExp(term, 'gi').test(sup)).splice(0, 10));


  setColors() {
    var mat = this.iForm.get('material').value;
    for(let i = 0; i< this.materials.length; i++) {
      if(this.materials[i].name == mat) {
        this.colors = this.materials[i].colors.sort((a,b)=>{
          if(a.name < b.name) return -1;
          if(a.name > b.name) return 1;
          return 0;
        });
        this.iForm.get('color').setValue(this.colors[0].name);
      }
    }
  }

  changeLShape() {
    var lshaped = this.iForm.get('lShape').value;
    if(!lshaped) {
      this.iForm.get('lDirection').setValue(null);
      this.iForm.get('lLength').setValue(null);
      this.iForm.get('lWidth').setValue(null);
    }
  }

  cancel() {
    this.iForm.reset();
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/create.component.ts